import React, { FC } from 'react';
import { Trash } from '@phosphor-icons/react';
import { CaretDown } from '@phosphor-icons/react';
import { FormStepNode } from '../workoutBuilderTypes';
import { VOLUME_MODE_OPTIONS } from './conditioningSteps.constants';
import StepIntensityField from './StepIntensityField';
import StepRecoveryField from './StepRecoveryField';
import styles from './ConditioningSteps.module.scss';

interface StepSingleRowProps {
  node: FormStepNode;
  onChange: (patch: Partial<FormStepNode>) => void;
  onRemove: () => void;
  compact?: boolean;
  previewAthleteId?: string;
}

const StepSingleRow: FC<StepSingleRowProps> = ({ node, onChange, onRemove, compact = false, previewAthleteId }) => {
  return (
    <div className={compact ? styles.stepRowCompact : styles.stepRow}>
      <div className={styles.stepRowTop}>
        <input
          type="text"
          className={styles.compactInput}
          placeholder="es. warmup"
          value={node.label}
          onChange={(e) => onChange({ label: e.target.value })}
          style={{ minWidth: 80, maxWidth: 110 }}
        />

        <div className={styles.selectWrapper}>
          <select
            className={styles.compactSelect}
            value={node.volumeMode}
            onChange={(e) =>
              onChange({ volumeMode: e.target.value as FormStepNode['volumeMode'] })
            }
          >
            {VOLUME_MODE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <CaretDown size={11} className={styles.selectIcon} />
        </div>

        <input
          type="number"
          className={styles.compactInput}
          placeholder="400"
          value={node.volumeValue}
          min={0}
          onChange={(e) => onChange({ volumeValue: e.target.value })}
          style={{ maxWidth: 80 }}
        />

        <button
          type="button"
          className={styles.removeBtn}
          onClick={onRemove}
          title="Rimuovi tratto"
        >
          <Trash size={14} />
        </button>
      </div>

      <div className={styles.stepRowBottom}>
        <StepIntensityField
          value={node.intensity}
          previewAthleteId={previewAthleteId}
          onChange={(intensity) => onChange({ intensity })}
        />
        <StepRecoveryField
          value={node.recovery}
          previewAthleteId={previewAthleteId}
          onChange={(recovery) => onChange({ recovery })}
        />
      </div>
    </div>
  );
};

export default StepSingleRow;
